module.exports = __webpack_public_path__ + "img/white_paper8.dcb6aaf9.png";